module.exports = __webpack_public_path__ + "img/3_26.00a9b3bf.png";